import request from '../../utils/requests'
/** * Tag: Sys */
const baseUrl ="/api/Sys";

/** * 用户登陆系统 * @param {*} param * { *    type Desc:分组org/branch/coach/student/data Required:false * } */async function _getUserInfoLogin(param) {  return request(baseUrl+'/getUserInfoLogin',{    method: 'GET',    params: param,  });
}

/** * 获取所有菜单 */async function _getAllMenu() {  return request(baseUrl+'/getAllMenu',{    method: 'GET',  });
}

export default{  _getUserInfoLogin,  _getAllMenu}



// WEBPACK FOOTER //
// ./src/services/sys.js